// auth.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AUTH_CONFIG, AuthConfig } from './auth.config';

export interface AuthHeaders {
  'access-token': string | null;
  client: string | null;
  uid: string | null;
  expiry: string | null;
  'token-type': string | null;
}

const TOKEN_KEY = 'dta_headers';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private config = inject<AuthConfig>(AUTH_CONFIG);

  //login(credentials: { email: string; password: string; customer_id?: string }): Observable<HttpResponse<any>> {
  login(credentials: any): Observable<HttpResponse<any>> {
    const url = `${this.config.apiBase}/${this.config.signInPath}`;
    return this.http.post(
      url, 
      credentials, { observe: 'response', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, ).pipe(
      tap(res => this.storeHeadersFromResponse(res))
    );
  }

  logout(): Observable<any> {
    const url = `${this.config.apiBase}/${this.config.signOutPath}`;
    return this.http.delete(url).pipe(tap(() => this.clearHeaders()));
  }

  isLoggedIn(): boolean {
    return !!this.getHeaders()?.['access-token'];
  }

  getHeaders(): AuthHeaders | null {
    const raw = localStorage.getItem(TOKEN_KEY);
    return raw ? JSON.parse(raw) as AuthHeaders : null;
  }

  storeHeadersFromResponse(res: HttpResponse<any>) {
    const headers = res.headers;
    const newHeaders: AuthHeaders = {
      'access-token': headers.get('access-token'),
      client: headers.get('client'),
      uid: headers.get('uid'),
      expiry: headers.get('expiry'),
      'token-type': headers.get('token-type')
    };

    // Only save if DTA actually sent a (refreshed) token
    if (newHeaders['access-token']) {
      localStorage.setItem(TOKEN_KEY, JSON.stringify(newHeaders));
    }
  }

  clearHeaders() {
    localStorage.removeItem(TOKEN_KEY);
  }
}
